import { Box } from '@skin-seoul/design-system';

import { HiddenGemSection } from './HiddenGemSection/HiddenGemSection';
import { AmazonSection } from './AmazonSection/AmazonSection';
import { BeforeAfterSlider } from '../components/BeforeAfterSlider';

export const GGUSection = () => {
  return (
    <Box
      width="100%"
      background="#ffffff"
      boxSizing="border-box"
      maxWidth={{
        base: '100%',
        tablet: '1280px',
      }}
      margin={{
        base: 0,
        tablet: '0 auto',
      }}
    >
      <Box width="100%" height="100%" display={{ base: 'none', desktop: 'block' }}>
        <BeforeAfterSlider
          content={{
            rightSection: <HiddenGemSection />,
            leftSection: <AmazonSection />,
          }}
        />
      </Box>
      <Box width="100%" height="100%" display={{ base: 'block', desktop: 'none' }}>
        <AmazonSection />
        <HiddenGemSection />
      </Box>
    </Box>
  );
};
